import React from 'react'
import colors from '../theme/colors'
import Title from '../components/titles'
import styled from 'styled-components'
import HTMLBlock from '../components/html-content'
import { GatsbyImage } from 'gatsby-plugin-image'
import get from 'lodash.get'

export const BodySwitch = (body) => {
    const content = body.body.map((item, index) => {
        const sliceType = get(item, 'slice_type')

        switch (sliceType) {
            case 'rich_text_slice':
                const htmlContent = item.primary.text.html
                return (
                    <StyledHtmlContainer key={`${item.id}-${index}`}>
                        <HTMLBlock>{htmlContent}</HTMLBlock>
                    </StyledHtmlContainer>
                )
            case 'image_slice':
                const alt = get(item, 'primary.image.alt')
                const image = get(item, 'primary.image.localFile.childImageSharp.gatsbyImageData')
                return (
                    <StyledImageContainer key={`${item.id}-${index}`}>
                        <StyledImage alt={alt || 'illustration'} image={image} />
                    </StyledImageContainer>
                )
            case  'kpi_slice':
                return (
                    <StyledKpiContainer key={`${item.id}-${index}`}>
                        {item.items.map((kpi, index) => {
                            return (
                                <StyledKpi key={`${kpi.kpi_number}-${index}`}>
                                    <p>{kpi.kpi_label}</p>
                                    <Title as='p' size='large' over='light'>
                                        {kpi.kpi_number}
                                    </Title>
                                </StyledKpi>
                            )
                        })}
                    </StyledKpiContainer>
                )
            case  'text-image':
                const textFirst = get(item, 'primary.text_first')
                const imgInside = get(item, 'primary.image_position')
                const imgContain = get(item, 'primary.image_style')
                const imgRadius = get(item, 'primary.image_radius')
                console.log(item)
                return (
                    <StyledTextImage $textFirst={textFirst} key={`${item.id}-${index}`} $imgRadius={imgRadius}>
                        {imgInside ? (
                            <StyledTextImageContainer>
                                <GatsbyImage
                                    alt={get(item, 'primary.alt') || 'illustration'}
                                    image={get(item, 'primary.image.localFile.childImageSharp.gatsbyImageData')}
                                    imgStyle={{
                                        objectFit: imgContain ? 'contain' : 'cover',
                                        objectPosition: 'center'
                                    }}
                                    style={{
                                        width: 'auto',
                                        height: '100%'
                                    }}
                                />
                            </StyledTextImageContainer>
                        ) : (
                            <>
                                <StyledTextImageSpacer />
                                <StyledTextImageIllustration $textFirst={textFirst}>
                                    <GatsbyImage
                                        alt={get(item, 'primary.alt') || 'illustration'}
                                        image={get(item, 'primary.image.localFile.childImageSharp.gatsbyImageData')}
                                        imgStyle={{
                                            objectFit: imgContain ? 'contain' : 'cover',
                                            objectPosition: textFirst ? 'left' : 'right'
                                        }}
                                        style={{
                                            width: 'auto',
                                            height: '100%',
                                            borderRadius: imgRadius ? '0.5rem' : '0'
                                        }}
                                    />
                                </StyledTextImageIllustration>
                            </>
                        )}
                        <StyledTextImageContent>
                            <HTMLBlock>
                                {get(item, 'primary.content.html')}
                            </HTMLBlock>
                        </StyledTextImageContent>
                    </StyledTextImage>
                )
            default:
                return (
                    <span key={`none-${index}`} />
                )
        }
    })
    return (
        <div>
            {content}
        </div>
    )
}

const StyledHtmlContainer = styled.div`
  margin-bottom: 4rem;

  img {
    max-width: 100%;
  }

  pre {
    padding: 0.25rem 0 1rem 0;
  }
`

const StyledImageContainer = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`

const StyledImage = styled(GatsbyImage)`
  width: auto;
  max-width: 100%;
  height: auto;
  margin: auto
`

const StyledTextImage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;

  img {
    border-radius: ${props => props.$imgRadius ? '0.5rem' : '0'};
  }

  @media (min-width: 900px) {
    gap: 2rem;
    flex-direction: ${props => props.$textFirst ? 'row-reverse' : 'row'};
  }
`

const StyledTextImageContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  @media (min-width: 900px) {
    width: 33%;
  }
`

const StyledTextImageSpacer = styled.div`
  width: 33%;
`

const StyledTextImageContent = styled.div`
  padding: 1rem 0;
  @media (min-width: 900px) {
    width: 66%;
  }
`

const StyledTextImageIllustration = styled.div`
  position: relative;
  display: flex;
  width: 100%;

  @media (min-width: 900px) {
    position: absolute;
    width: 66%;
    height: 100%;
    ${props => props.$textFirst ? 'margin-right: -33%' : 'margin-left: -33%'};
  }
`

const StyledKpiContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1px;
  margin-bottom: 4rem;
  justify-content: center;
  background-color: rgba(33, 41, 77, 0.10);
  border: 1px solid rgba(33, 41, 77, 0.10);
  border-radius: 0.5rem;
  overflow: hidden;

  p {
    padding: 0;
    color: ${colors.darkBlue};
  }
`

const StyledKpi = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 2rem;
  justify-content: center;
  background-color: ${colors.white};
`